<template>
  <tr>
    <td>
        {{item.descricaoOrigem}}
    </td>
    <td>
        {{item.entidadeOrigem}}
    </td>

    <td>
        {{item.problema}}
    </td>

    <td>
        {{$date.format(item.dataCadastro)}}
    </td>

  </tr>
</template>

<script>
    export default {

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },


        computed: {
            item() {
                return this.dataItem
            }

        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

</style>
